import { useCallback, useEffect, useRef, useState } from 'react';

const NOTIFICATION_SOUND = '/images/mixkit-software-interface-start-2574.wav';
const STORAGE_KEY = 'livechat_sound_muted';
const MIN_GAP_MS = 2500;

const readMuted = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * صدای پیام جدید صندوق گفتگو: یک فایل صوتی مشترک، حداکثر هر ۲.۵ ثانیه یک‌بار،
 * با امکان بی‌صدا کردن که در مرورگر اپراتور ذخیره می‌شود.
 */
const useIncomingSound = () => {
  const [muted, setMuted] = useState(readMuted);
  const mutedRef = useRef(muted);
  const audioRef = useRef(null);
  const lastPlayedAt = useRef(0);

  useEffect(() => {
    mutedRef.current = muted;
    try {
      localStorage.setItem(STORAGE_KEY, muted ? '1' : '0');
    } catch {
      // ذخیره اختیاری است
    }
  }, [muted]);

  const play = useCallback(() => {
    if (mutedRef.current) return;
    const now = Date.now();
    if (now - lastPlayedAt.current < MIN_GAP_MS) return;
    lastPlayedAt.current = now;
    try {
      audioRef.current = audioRef.current || new Audio(NOTIFICATION_SOUND);
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {
        // مرورگر تا اولین تعامل کاربر با صفحه پخش خودکار را مسدود می‌کند
      });
    } catch {
      // ignore
    }
  }, []);

  const toggleMuted = useCallback(() => setMuted((m) => !m), []);

  return { play, muted, toggleMuted };
};

export default useIncomingSound;
